import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class SwiperSlider {
   static initMainBannerSwiper(){
       const MainBannerSwiper = new Swiper(".swiper__main_banner", {
           spaceBetween: 0,
           loop: true,
           autoplay: {
               delay: 3000,
               disableOnInteraction: false,
           },
           pagination: {
               el: ".swiper-pagination",
               dynamicBullets: true,
           },
           navigation: {
               nextEl: ".swiper-button-next",
               prevEl: ".swiper-button-prev",
           },
       });
   }
}
